/* LeParfin V3 · thème Shopify : JavaScript global (window.LP).
   Panier (tiroir + page) rendu depuis /cart.js, délégation d'événements, menu, bandeau d'annonce,
   en-tête, apparitions (.in), toast, modales. Chargé en defer sur toutes les pages. */
(() => {
  'use strict';

  const D = window.LP_DATA || {};
  const T = D.t || {};
  const PERF = D.perfumes || {};
  const ORDER = (D.order || []).filter(h => PERF[h]);
  const R = Object.assign({ root: '/', cart: '/cart', add: '/cart/add', change: '/cart/change', update: '/cart/update' }, D.routes || {});
  const URLS = D.urls || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fill = (tpl, key, val) => String(tpl == null ? '' : tpl).split('[' + key + ']').join(val);

  /* Prix au format de la maquette : 29,90 € */
  function money(cents) {
    const n = Math.round(Number(cents) || 0);
    const s = (Math.abs(n) / 100).toFixed(2).replace('.', ',') + ' €';
    return n < 0 ? '−' + s : s;
  }

  const byVariant = {};
  Object.keys(PERF).forEach(h => { if (PERF[h].variantId) byVariant[String(PERF[h].variantId)] = h; });
  const perfumeOf = it => (it && PERF[it.handle]) ? it.handle : (it && byVariant[String(it.variant_id)]) || null;
  const freeCount = n => n >= 5 ? 2 : n >= 3 ? 1 : 0;

  /* V38 : pochette cadeau payante (LP_DATA.giftWrap). Ligne du panier masquée de la liste : elle est pilotée
     par une case décochée par défaut, au-dessus du récapitulatif (tiroir et page panier). Quantité 1, ajout par
     /cart/add.js, retrait par /cart/change.js ; le petit mot est un attribut de commande (/cart/update.js). */
  const GW = Object.assign({ enabled: false, handle: '', variantId: 0, price: 0, label: '', sub: '', noteLabel: '', notePlaceholder: '', noteAttr: 'Petit mot', noteMax: 200 }, D.giftWrap || {});
  const isGW = it => !!(it && GW.variantId && (String(it.variant_id) === String(GW.variantId) || (GW.handle && it.handle === GW.handle)));

  /* V52 (07/10) : pochette offerte = vraie ligne du panier (produit « Pochette offerte » à 0 €, LP_DATA.freePochette).
     Ajoutée dès 5 parfums, retirée en dessous, toujours en 1 exemplaire : elle arrive dans la commande sans ajout manuel.
     Ligne masquée de la liste (la ligne « Pochette · Offerte » s'affiche comme avant) et non comptée dans le nombre d'articles. */
  const FP = Object.assign({ handle: '', variantId: 0 }, D.freePochette || {});
  const isFP = it => !!(it && FP.variantId && (String(it.variant_id) === String(FP.variantId) || (FP.handle && it.handle === FP.handle)));

  /* V58 (09/10) : panier V3.4.
     - Code promo (LP_DATA.promo) : le code s'affiche avec un bouton « Copier », puis le client le colle dans le champ du panier
       et appuie sur « Appliquer » (demande de Maxime : on doit le copier et le coller, pas un simple clic). Le champ accepte
       tout code valable (PARF15, COMEBACK…). Appliqué par /cart/update.js { discount }, puis le panier est relu.
     - Bannière du haut : « Forte demande » + compte à rebours jusqu'à la VRAIE fin de l'offre (LP_DATA.offerEnd,
       AAAA-MM-JJ HH:MM, heure de Paris). Date passée ou vide : le décompte disparaît. */
  const PROMO = Object.assign({ show: false, code: '', text: '', copy: 'Copier', copied: 'Copié !', placeholder: '', apply: 'Appliquer', applied: 'Code [code] appliqué', line: 'Code [code]', error: '', empty: '', remove: 'Retirer' }, D.promo || {});
  const FLOCON = '<svg class="lp-fl" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 12L12.00 2.50M14.60 4.00L12.00 6.40L9.40 4.00M12 12L3.77 7.25M6.37 5.75L7.15 9.20L3.77 10.25M12 12L3.77 16.75M3.77 13.75L7.15 14.80L6.37 18.25M12 12L12.00 21.50M9.40 20.00L12.00 17.60L14.60 20.00M12 12L20.23 16.75M17.63 18.25L16.85 14.80L20.23 13.75M12 12L20.23 7.25M20.23 10.25L16.85 9.20L17.63 5.75" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const STAR = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2.6l2.83 5.94 6.52.78-4.8 4.5 1.24 6.45L12 17.1l-5.79 3.17 1.24-6.45-4.8-4.5 6.52-.78z"/></svg>';
  const COPY_IC = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="8.5" y="8.5" width="11" height="11" rx="2" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M15.5 8.5V6.5a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h2" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';
  let promoErr = '';
  let codeBusy = false;
  /* V58m (10/10) : Shopify découpe les lignes d'un même parfum quand l'offre s'applique (ex. Velora ×1 payant, ×1 offert,
     ×2 payants). Le panier les regroupe : une carte pour les payants, une pour les offerts. VIEW garde, par carte, les lignes
     Shopify regroupées. Les quantités et la suppression réagissent tout de suite à l'écran ; Shopify est mis à jour en
     arrière-plan (un seul envoi après une rafale d'appuis), puis le panier se redessine avec la réponse. */
  let VIEW = {};
  function mergeView(items) {
    const out = [], map = {};
    VIEW = {};
    (items || []).forEach(it => {
      if (packOf(it)) { const gid = 'k:' + it.key; out.push(Object.assign({}, it, { _gid: gid })); VIEW[gid] = { qty: it.quantity, keys: [{ key: it.key, q: it.quantity }] }; return; }
      const free = it.final_line_price === 0 && it.original_line_price > 0;
      const gid = 'v:' + it.variant_id + '|' + (free ? 'f' : 'p') + '|' + (it.properties ? JSON.stringify(it.properties) : '');
      let g = map[gid];
      if (!g) {
        g = map[gid] = Object.assign({}, it, { _gid: gid, quantity: 0, original_line_price: 0, final_line_price: 0 });
        VIEW[gid] = { qty: 0, keys: [] };
        out.push(g);
      }
      g.quantity += it.quantity; g.original_line_price += it.original_line_price; g.final_line_price += it.final_line_price;
      VIEW[gid].qty += it.quantity; VIEW[gid].keys.push({ key: it.key, q: it.quantity });
    });
    return out;
  }
  const pendQ = {}, flyQ = {};
  let qBusy = false, qTimer = 0, qWaiters = [];
  function markPending(on) { $$('[data-lp-cart]').forEach(r => r.classList.toggle('lp-pending', on)); }
  function qtyIdle() {
    if (!qBusy && !Object.keys(pendQ).length) return Promise.resolve();
    return new Promise(r => { qWaiters.push(r); clearTimeout(qTimer); flushQty(); setTimeout(r, 9000); });
  }
  async function flushQty() {
    if (qBusy) return;
    const gids = Object.keys(pendQ);
    if (!gids.length) return;
    qBusy = true;
    const updates = {};
    gids.forEach(gid => {
      const target = pendQ[gid]; delete pendQ[gid]; flyQ[gid] = target;
      const g = VIEW[gid];
      if (!g) return;
      let diff = target - g.qty;
      const ks = g.keys.map(k => ({ key: k.key, q: k.q }));
      if (diff > 0) ks[0].q += diff;
      else for (let i = ks.length - 1; i >= 0 && diff < 0; i--) { const take = Math.min(ks[i].q, -diff); ks[i].q -= take; diff += take; }
      ks.forEach(k => { updates[k.key] = k.q; });
    });
    try {
      const keys = Object.keys(updates);
      if (keys.length === 1) cart = await req(R.change + '.js', { id: keys[0], quantity: updates[keys[0]] });
      else if (keys.length) { await req(R.update + '.js', { updates }); cart = await req(R.cart + '.js'); }
    } catch (e) {
      toast(e.message || T.error);
      try { cart = await req(R.cart + '.js'); } catch (x) {}
    }
    gids.forEach(gid => { delete flyQ[gid]; });
    qBusy = false;
    mergeView(stats(cart).items);
    if (Object.keys(pendQ).length) return flushQty();
    markPending(false);
    render();
    emit('lp:cart:updated', { cart });
    const w = qWaiters; qWaiters = []; w.forEach(r => r());
  }
  /* V58b (09/10) : panier inspiré de Rebelle, dans la DA (encre, fond doux, cartes blanches, pilules). */
  const IC_TRUCK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 6.5h11v9H3zM14 9.5h3.6l3.4 3.6v2.4h-7" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="7" cy="17" r="1.8" fill="#fff" stroke="currentColor" stroke-width="1.7"/><circle cx="17.5" cy="17" r="1.8" fill="#fff" stroke="currentColor" stroke-width="1.7"/></svg>';
  const IC_GIFT = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 10h16v10H4zM3 7h18v3H3zM12 7v13M12 7c-1.5-3-5-3.2-5-1.2C7 7 9.5 7 12 7zm0 0c1.5-3 5-3.2 5-1.2C17 7 14.5 7 12 7z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
  const IC_BAG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 8h14l-1.2 12H6.2zM9 8V6.5a3 3 0 0 1 6 0V8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
  const IC_X = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  /* Codes valables du panier Shopify. */
  const codesOn = () => ((cart && Array.isArray(cart.discount_codes)) ? cart.discount_codes : []).filter(x => x && x.code && x.applicable !== false).map(x => String(x.code));
  /* Pilule du code en haut du panier : un appui copie le code et place le curseur dans le champ du bas. */
  function promoHTML() {
    if (!PROMO.show) return '';
    const on = codesOn();
    if (on.length) {
      const c = on[0];
      const txt = c.toUpperCase() === String(PROMO.code).toUpperCase() ? PROMO.applied : 'Code [code] appliqué';
      return `<p class="lp-pill lp-pill-on">${CHECK}<span>${esc(fill(txt, 'code', c))}</span></p>`;
    }
    if (!PROMO.code) return '';
    return `<button type="button" class="lp-pill" data-lp-copy aria-label="${esc(PROMO.copy + ' ' + PROMO.code)}"><span data-lp-copy-l>${esc(PROMO.text)} <b>${esc(PROMO.code)}</b></span></button>`;
  }
  /* Champ du code, dans le pied du panier (au-dessus de Commander). */
  function codeSlotHTML() {
    if (!PROMO.show) return '';
    const on = codesOn();
    if (on.length) return `<p class="lp-code-on">${CHECK}<span>${esc(fill(PROMO.line || 'Code [code]', 'code', on[0]))}</span><button type="button" class="lp-code-rm" data-lp-code-rm="${esc(on[0])}">${esc(PROMO.remove)}</button></p>`;
    return `<form class="lp-code-f" data-lp-code-f novalidate><input type="text" name="code" data-lp-code-in placeholder="${esc(PROMO.placeholder)}" autocomplete="off" autocorrect="off" autocapitalize="characters" spellcheck="false" enterkeyhint="done" aria-label="${esc(PROMO.placeholder || 'Code promo')}"><button type="submit">${esc(PROMO.apply)}</button></form>`
      + (promoErr ? `<p class="lp-code-e" role="alert">${esc(promoErr)}</p>` : '');
  }
  function endAt(v) {
    const m = String(v || '').match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return 0;
    return new Date(+m[1], +m[2] - 1, +m[3], m[4] != null ? +m[4] : 23, m[5] != null ? +m[5] : 59).getTime();
  }
  function cdText(ms) {
    const t = Math.max(0, Math.floor(ms / 1000));
    const d = Math.floor(t / 86400), h = Math.floor(t % 86400 / 3600), mi = Math.floor(t % 3600 / 60), s = t % 60;
    const p = n => String(n).padStart(2, '0');
    return d > 0 ? `${d} j ${p(h)} h ${p(mi)} min ${p(s)} s` : `${p(h)} h ${p(mi)} min ${p(s)} s`;
  }
  function bannerHTML() {
    const txt = D.cartBanner || '';
    const end = endAt(D.offerEnd);
    const live = !!end && end > Date.now();
    if (!txt && !live) return '';
    const cd = live ? `<span>${txt ? '' : FLOCON}${esc(D.offerEndLabel || '')} <b data-lp-cd>${esc(cdText(end - Date.now()))}</b></span>` : '';
    return `<p class="lp-cd-bar"${live ? ` data-lp-end="${esc(D.offerEnd)}"` : ''}>${txt ? `<strong>${FLOCON}${esc(txt)}</strong>` : ''}${cd}</p>`;
  }
  function tickCd() {
    document.querySelectorAll('[data-lp-end]').forEach(el => {
      const left = endAt(el.getAttribute('data-lp-end')) - Date.now();
      const b = el.querySelector('[data-lp-cd]');
      if (left <= 0) { if (b && b.parentNode) b.parentNode.remove(); el.removeAttribute('data-lp-end'); return; }
      if (b) b.textContent = cdText(left);
    });
  }

  /* ---------- Verrouillage du défilement ---------- */
  function lock() { document.body.classList.add('lock'); }
  function unlock() {
    if (!$('.drawer.open, .menu.open, .smell-box.on, .smell-box:not([hidden]), .modal:not([hidden])')) document.body.classList.remove('lock');
  }

  /* ---------- Toast ---------- */
  let toastT;
  function toast(msg) {
    const d = $('#drawer');
    if (d && d.classList.contains('open')) return;
    const t = $('#toast');
    if (!t || !msg) return;
    t.textContent = msg;
    t.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(() => t.classList.remove('on'), 2200);
  }

  /* ---------- Panier : état et requêtes ---------- */
  let cart = D.cart || null;
  const isCartPage = D.template === 'cart' || document.body.dataset.template === 'cart';

  async function req(url, body) {
    const opts = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    const r = await fetch(url, opts);
    let j = null;
    try { j = await r.json(); } catch (e) { j = null; }
    if (!r.ok) {
      const err = new Error((j && (j.description || j.message)) || T.error || '');
      err.status = r.status;
      throw err;
    }
    return j;
  }

  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail })); }

  async function refresh() {
    cart = await req(R.cart + '.js');
    render();
    emit('lp:cart:updated', { cart });
    return cart;
  }

  async function add(items, opts) {
    const o = opts || {};
    /* Propriétés de ligne transmises (ex. _lp_pack du Pack de Noël) ; seules les lignes identiques
       (même variante ET mêmes propriétés) sont fusionnées. */
    const list = (Array.isArray(items) ? items : [items])
      .map(x => {
        if (!x || typeof x !== 'object') return { id: Number(x), quantity: 1 };
        const line = { id: Number(x.id), quantity: Math.max(1, Number(x.quantity) || 1) };
        if (x.properties && typeof x.properties === 'object' && Object.keys(x.properties).length) line.properties = x.properties;
        return line;
      })
      .filter(x => x.id);
    const sig = x => x.id + '|' + (x.properties ? JSON.stringify(x.properties) : '');
    const merged = [];
    list.forEach(x => { const m = merged.find(y => sig(y) === sig(x)); if (m) m.quantity += x.quantity; else merged.push(x); });
    if (!merged.length) return cart;
    try {
      await req(R.add + '.js', { items: merged });
    } catch (e) {
      toast(e.message || T.error);
      throw e;
    }
    await refresh();
    emit('lp:cart:added', { items: merged, cart });
    if (o.open !== false && !isCartPage) openCart();
    return cart;
  }

  async function change(key, quantity) {
    try {
      cart = await req(R.change + '.js', { id: key, quantity: Math.max(0, Number(quantity) || 0) });
    } catch (e) {
      toast(e.message || T.error);
      return refresh().catch(() => cart);
    }
    render();
    emit('lp:cart:updated', { cart });
    return cart;
  }

  /* ---------- Panier : rendu (reprend renderCart() et goals() de la V3) ---------- */
  function stats(c) {
    const items = (c && c.items) || [];
    let units = 0;
    items.forEach(it => { if (perfumeOf(it)) units += it.quantity; });
    const sub = (c && c.total_price) || 0;
    const orig = c ? (c.original_total_price != null ? c.original_total_price : c.items_subtotal_price) : 0;
    const disc = (c && c.total_discount) || 0;
    const free = D.freeShipping != null ? D.freeShipping : 4900;
    const cost = D.shipCost != null ? D.shipCost : 390;
    const ship = sub === 0 ? 0 : (sub >= free ? 0 : cost);
    const gift = D.giftEnabled !== false && units >= (D.giftMin || 5);
    const gw = items.filter(isGW);
    const gwQty = gw.reduce((a, it) => a + it.quantity, 0);
    const fpQty = items.filter(isFP).reduce((a, it) => a + it.quantity, 0);
    const list = items.filter(it => !isGW(it) && !isFP(it));
    /* V58 : part de la remise venant d'un code (PARF10…), affichée sur sa propre ligne. */
    const codeApps = ((c && c.cart_level_discount_applications) || []).filter(a => a && a.type === 'discount_code');
    const codeDisc = Math.min(disc, codeApps.reduce((t, a) => t + (Number(a.total_allocated_amount) || 0), 0));
    const codeName = codeApps.length ? String(codeApps[0].title || codeApps[0].key || '') : '';
    const origTotal = orig + (orig === 0 || orig >= free ? 0 : cost);
    return { items: list, gw, units, count: Math.max(0, ((c && c.item_count) || 0) - gwQty - fpQty), sub, orig, disc, codeDisc, codeName, ship, total: sub + ship, origTotal, gift, free: freeCount(units) };
  }

  /* V3.7 (13/10) : panier moyen. Repères de prix dans les textes du panier : [prix] (un parfum), [prix3] et [prix5]
     (prix par parfum à 3 et à 5), [pochette] (valeur réelle de la pochette). Réglages : Paramètres du thème > Panier moyen (V3.7). */
  const PM = Object.assign({ up5: true, lock: true, big: true, save: true }, D.pm || {});
  const IC_PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5.5v13M5.5 12h13" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
  const IC_LOCK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="5" y="10.5" width="14" height="10" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5" fill="none" stroke="currentColor" stroke-width="1.7"/></svg>';
  function unitPrice() {
    let m = 0;
    ORDER.forEach(h => { const p = PERF[h]; if (p && p.price && (!m || p.price < m)) m = p.price; });
    return m;
  }
  function pochVal() { return D.pochette && D.pochette.value > 0 ? D.pochette.value : 0; }
  function pmFill(str) {
    const u = unitPrice(), pv = pochVal();
    let out = String(str == null ? '' : str);
    if (!pv) out = out.split(' (valeur [pochette])').join('');
    out = fill(out, 'prix3', money(Math.floor(u * 2 / 3)));
    out = fill(out, 'prix5', money(Math.floor(u * 3 / 5)));
    out = fill(out, 'prix', money(u));
    return fill(out, 'pochette', money(pv));
  }
  /* V3.11 (21/10) : temps restant de l'offre d'hiver sur la ligne « Offre d'hiver » de la bannière (même balisage que
     snippets/lp-cd.liquid, mis à jour chaque seconde par snippets/lp-v311.liquid ; rien après la date). */
  function offerCd() {
    const end = endAt(PM.offerEnd);
    const left = end ? Math.floor((end - Date.now()) / 1000) : 0;
    if (!(left > 0)) return '';
    const d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), mi = Math.floor(left % 3600 / 60), s = left % 60;
    const p = n => String(n).padStart(2, '0');
    const when = new Date(end);
    return `<span class="lp-cd lp-cd-mini" data-lp-cd2="${esc(PM.offerEnd)}" role="timer"><span class="lp-cd-l">fin dans</span><span class="sr"> (fin le ${when.getDate()}/${p(when.getMonth() + 1)} à ${when.getHours()} h ${p(when.getMinutes())})</span><span class="lp-cd-t" aria-hidden="true"><span data-cd-dw${d ? '' : ' hidden'}><b data-cd="d">${d}</b>&nbsp;j</span><b data-cd="h">${p(h)}</b>:<b data-cd="m">${p(mi)}</b>:<b data-cd="s">${p(s)}</b></span></span>`;
  }
  /* V3.7 (révision) : rappel de l'offre en haut du panier, au-dessus de la jauge. */
  function offerHTML() {
    if (PM.offer === false || !(PM.offerKicker || PM.offerText)) return '';
    const img = PM.offerImg ? `<img class="lp-offer-i" src="${esc(PM.offerImg)}" alt="" width="104" height="104" decoding="async">` : '';
    return `<div class="lp-offer">${img}<i class="lp-sn" aria-hidden="true"></i><div class="lp-offer-c">${PM.offerKicker ? `<p class="lp-offer-k">${FLOCON}<span>${esc(PM.offerKicker)}</span>${offerCd()}</p>` : ''}${PM.offerText ? `<p class="lp-offer-t">${PM.offerText}</p>` : ''}${PM.offerNote ? `<p class="lp-offer-n">${PM.offerNote}</p>` : ''}</div></div>`;
  }
  /* Carte « Passez à 5 parfums » (3 et 4 parfums) : ouverte d'office à 4 (le 5e est offert), sur appui à 3. */
  let up5Open = false;
  function up5HTML(u) {
    const four = u === 4;
    const open = four || up5Open;
    const pv = pochVal();
    const tiles = ORDER.filter(h => PERF[h] && PERF[h].variantId).map(h => {
      const p = PERF[h];
      const lab = four ? esc(T.upBtnGift) : esc(fill(T.upBtn, 'price', money(p.price)));
      const pr = four ? `<s>${money(p.price)}</s> <b>${esc(T.lineFree)}</b>` : money(p.price);
      return `<div class="lp-up lp-g5-c"${pAttrs(p)}><img src="${esc(p.packshot)}" alt="" width="64" height="64" loading="lazy" decoding="async"><p class="lp-g5-n">${esc(p.cap)}</p><span class="lp-up-pr">${pr}</span><form class="up-f" action="${esc(R.add)}" method="post"><input type="hidden" name="id" value="${p.variantId}"><input type="hidden" name="quantity" value="1"><button type="submit"${four ? ' class="gift"' : ''} data-add-variant="${p.variantId}" aria-label="${esc(lab + ' ' + p.cap)}">${IC_PLUS}</button></form></div>`;
    }).join('');
    if (!tiles) return '';
    const title = pmFill(four ? PM.t4 : PM.t3);
    const text = pmFill(four ? PM.x4 : PM.x3);
    const img = D.pochette && D.pochette.img && pv ? `<img class="lp-up5-i" src="${esc(D.pochette.img)}" alt="" width="52" height="52" loading="lazy" decoding="async">` : '';
    return `<div class="ups lp-ups lp-up5${open ? ' lp-up5-open' : ''}"><div class="lp-up5-c">${img}<div class="lp-up5-t">${title ? `<p class="lp-up5-h">${title}</p>` : ''}${text ? `<p class="lp-up5-x">${text}</p>` : ''}</div></div>`
      + (open ? '' : `<button type="button" class="lp-up5-b" data-lp-up5 aria-expanded="false">${esc(PM.btn || '')}</button>`)
      + `<div class="lp-up5-g"${open ? '' : ' hidden'}>${tiles}</div></div>`;
  }

  function goalsHTML(s, plan) {
    const u = s.units;
    const goals = T.goals || [];
    const msg = plan && plan.packs > 1 && PK_T.goalMany
      ? esc(fill(fill(PK_T.goalMany, 'n', plan.freeUnits), 'k', plan.packs))
      : pmFill(fill(goals[Math.min(u, 5)], 'total', money(s.total)));
    /* V58e (10/10) : 1re étape (3 parfums) au milieu de la barre, 2e (5 parfums) au bout ; la barre se remplit jusqu'à chaque étape.
       Laisse la place à « 2 offerts + pochette » sur une ligne. */
    const pos = n => n <= 3 ? n / 3 * 50 : 50 + (Math.min(n, 5) - 3) / 2 * 50;
    const pct = pos(Math.min(u, 5));
    const ic = s.items && s.items.length && s.ship > 0 ? IC_TRUCK : IC_GIFT;
    const step = (n, label, icon) => `<li class="${u >= n ? 'lp-st-on' : ''}" style="left:${pos(n)}%"><i>${icon}</i><span>${esc(label)}</span></li>`;
    return `<div class="goal lp-goal"><p><span class="lp-goal-ic">${ic}</span><span>${msg}</span></p><div class="goal-bar"><b style="width:${pct}%"></b><ol>${step(3, T.step1, IC_GIFT)}${step(5, T.step2, IC_BAG)}</ol></div></div>`;
  }

  const pAttrs = p => ` data-p="${esc(p.key)}" style="--g1:${esc(p.c1)};--g2:${esc(p.c2)};--deep:${esc(p.deep)}"`;
  const sized = (url, w) => url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : '';

  function lineHTML(it) {
    const h = perfumeOf(it);
    const p = h ? PERF[h] : null;
    const poch = D.pochette && it.handle === D.pochette.handle ? D.pochette : null;
    let name, sub, img;
    if (p) { name = p.name; sub = p.sub; img = p.packshot; }
    else if (poch) { name = poch.name; sub = poch.sub; img = poch.img; }
    else { name = (it.product_title || '').toUpperCase(); sub = it.product_has_only_default_variant ? '' : (it.variant_title || ''); img = sized(it.image, 160); }
    const o = it.original_line_price, f = it.final_line_price;
    let price;
    if (f === 0 && o === 0) price = `<b class="ln-free">${esc(T.lineFree)}</b>`;
    else if (f === 0 && o > 0) price = `<span class="ln-pr"><s>${money(o)}</s><b class="ln-free">${esc(T.lineFree)}</b></span>`;
    else if (f < o) price = `<span class="ln-pr"><s>${money(o)}</s>${money(f)}</span>`;
    else price = money(f);
    const key = esc(it.key);
    const gid = it._gid || ('k:' + it.key);
    if (!VIEW[gid]) VIEW[gid] = { qty: it.quantity, keys: [{ key: it.key, q: it.quantity }] };
    const pic = img ? `<img src="${esc(img)}" alt="" width="64" height="64" loading="lazy" decoding="async">` : '<span class="ln-ph" aria-hidden="true"></span>';
    const save = o - f > 0 ? `<span class="lp-save">${esc(fill(T.saved || '[amount] économisés', 'amount', money(o - f)))}</span>` : '';
    return `<div class="ln lp-ln"${p ? pAttrs(p) : ' data-p=""'}>${pic}<div class="ln-t"><p class="ln-n">${esc(name)}</p>${sub ? `<p class="lp-ln-sub">${esc(sub)}</p>` : ''}${save}</div><div class="ln-p">${price}<div class="qty"><button type="button" aria-label="${esc(T.removeOne)}" data-lp-q="${esc(gid)}" data-lp-d="-1">−</button><span>${it.quantity}</span><button type="button" aria-label="${esc(T.addOne)}" data-lp-q="${esc(gid)}" data-lp-d="1">+</button></div></div><a class="ln-rm lp-ln-x" href="${esc(R.change)}?id=${encodeURIComponent(it.key)}&amp;quantity=0" data-lp-rm="${esc(gid)}" aria-label="${esc(T.remove + ' ' + name)}">${IC_X}</a></div>`;
  }

  /* ---------- Pack de Noël : lignes reliées par la propriété cachée _lp_pack ----------
     Un coffret = ses lignes parfum (5 unités) + la ligne « coffret » (produit du pack, 0 €). Affiché en un seul bloc :
     nom, composition, total du coffret, « Retirer le coffret » (toutes ses lignes à 0). Une ligne coffret à laquelle il manque
     des parfums est retirée automatiquement. Textes : D.pack (facultatif), sinon ceux-ci.
     Aperçu (produit coffret pas encore publié) : les parfums portent _lp_preview (composition) et _lp_img (vignette) ; le
     panier les montre regroupés comme ils le seront, sans ligne coffret.
     Note de livraison : la note générale (LP_DATA.deliveryNote, réglage « Expédition » du thème) vaut aussi pour les coffrets
     (V38 : tout part à la même date) ; D.pack.note, s'il est rempli, la remplace quand le panier contient un coffret. */
  const PK_T = Object.assign({ remove: 'Retirer le coffret', box: 'Coffret à tiroir', orphan: 'Le coffret a été retiré : il lui manquait des parfums.', title: 'Pack de Noël · La Collection', goalMany: '[n] parfums offerts avec vos [k] coffrets de Noël.', note: '' }, D.pack || {});
  const packOf = it => (it && it.properties && it.properties._lp_pack) ? String(it.properties._lp_pack) : '';
  function packGroups(items) {
    const map = {};
    (items || []).forEach(it => {
      const id = packOf(it);
      if (!id) return;
      const g = map[id] || (map[id] = { id, lines: [], box: null, units: 0, preview: '', img: '' });
      const pv = it.properties._lp_preview;
      if (pv && !g.preview) { g.preview = String(pv); g.img = String(it.properties._lp_img || ''); }
      if (perfumeOf(it)) { g.lines.push(it); g.units += it.quantity; }
      else if (!g.box) g.box = it;
      else g.lines.push(it);
    });
    return map;
  }
  const packOk = g => !!(g && g.units >= 5 && (g.box || g.preview));

  /* Remises affichées quand le panier contient un coffret. Shopify répartit la remise « 3 achetés = 2 offerts » sur
     n'importe quelles lignes : deux coffrets s'afficheraient à 29,90 € et 149,50 €, un coffret et un parfum seul à 119,60 €
     et « Offert ». Ici, chaque coffret montre ses 2 parfums les moins chers offerts (le prix promis), et le reste de la remise
     va aux autres parfums, des moins chers aux plus chers. Les totaux du panier ne changent pas. Seulement si la remise réelle
     couvre ces parfums offerts ; sinon, la répartition de Shopify est gardée telle quelle. */
  function packPlan(items, totalDisc) {
    const groups = packGroups(items);
    const ok = Object.keys(groups).map(id => groups[id]).filter(packOk);
    if (!ok.length) return null;
    const unitOf = it => Math.round((it.original_line_price || 0) / (it.quantity || 1));
    const free = {};
    const give = (it, d) => { free[it.key] = (free[it.key] || 0) + d; };
    let nominal = 0;
    let freeUnits = 0;
    ok.forEach(g => {
      const units = [];
      g.lines.forEach(it => { if (perfumeOf(it)) for (let q = 0; q < it.quantity; q++) units.push(it); });
      units.sort((a, b) => unitOf(a) - unitOf(b)).slice(0, 2).forEach(it => { give(it, unitOf(it)); nominal += unitOf(it); freeUnits += 1; });
    });
    if ((Number(totalDisc) || 0) + 1 < nominal) return null;
    let rest = (Number(totalDisc) || 0) - nominal;
    const others = [];
    items.forEach(it => { if (!packOk(groups[packOf(it)]) && perfumeOf(it)) for (let q = 0; q < it.quantity; q++) others.push(it); });
    others.sort((a, b) => unitOf(a) - unitOf(b)).forEach(it => {
      if (rest <= 0) return;
      const d = Math.min(rest, unitOf(it));
      give(it, d);
      rest -= d;
      if (d === unitOf(it)) freeUnits += 1;
    });
    return { free, freeUnits, packs: ok.length };
  }
  const planned = (it, plan) => (plan && it ? Object.assign({}, it, { final_line_price: Math.max(0, (it.original_line_price || 0) - (plan.free[it.key] || 0)) }) : it);

  function packHTML(g0, plan) {
    const g = Object.assign({}, g0, { lines: g0.lines.map(it => planned(it, plan)), box: planned(g0.box, plan) });
    const box = g.box;
    const all = box ? g.lines.concat([box]) : g.lines;
    const o = all.reduce((a, it) => a + (it.original_line_price || 0), 0);
    const f = all.reduce((a, it) => a + (it.final_line_price || 0), 0);
    const parts = String((box ? box.product_title : PK_T.title) || '').split(' · ');
    const name = (parts.length > 1 ? parts[parts.length - 1] : parts[0]).toUpperCase();
    const sub = parts.length > 1 ? parts.slice(0, -1).join(' · ') : '';
    const props = (box && box.properties) || {};
    const comp = box ? Object.keys(props).filter(k => k.charAt(0) !== '_' && props[k]).map(k => props[k]).join(' · ') : g.preview;
    const img = box ? sized(box.image, 160) : g.img;
    const pic = img ? `<img src="${esc(img)}" alt="" width="74" height="74" loading="lazy" decoding="async">` : '<span class="ln-ph" aria-hidden="true"></span>';
    const price = f < o ? `<span class="ln-pr"><s>${money(o)}</s>${money(f)}</span>` : money(f);
    const rows = g.lines.map(it => {
      const h = perfumeOf(it);
      const p = h ? PERF[h] : {};
      const lo = it.original_line_price, lf = it.final_line_price;
      const pr = (lf === 0 && lo > 0) ? `<s>${money(lo)}</s><b class="ln-free">${esc(T.lineFree)}</b>` : (lf < lo ? `<s>${money(lo)}</s>${money(lf)}` : money(lf));
      const thumb = p.packshot || sized(it.image, 96);
      return `<li${p.key ? pAttrs(p) : ''}>${thumb ? `<img src="${esc(thumb)}" alt="" width="40" height="40" loading="lazy" decoding="async">` : '<span class="lnk-i" aria-hidden="true"></span>'}<span class="lnk-n">${esc(p.cap || it.product_title)}${it.quantity > 1 ? ' ×' + it.quantity : ''}</span><span class="lnk-p">${pr}</span></li>`;
    }).join('') + `<li class="lnk-box"><span class="lnk-i" aria-hidden="true"></span><span class="lnk-n">${esc(PK_T.box)}</span><span class="lnk-p"><b class="ln-free">${esc(T.lineFree)}</b></span></li>`;
    return `<div class="ln ln-pk" data-p="" data-pack="${esc(g.id)}">${pic}<div class="ln-t"><p class="ln-n">${esc(name)}</p><p class="ln-s">${esc(sub)}</p>${comp ? `<p class="ln-c">${esc(comp)}</p>` : ''}</div><div class="ln-p">${price}<a class="ln-rm" href="${esc(R.cart)}" data-cart-pack-rm="${esc(g.id)}">${esc(PK_T.remove)}</a></div><ul class="lnk" role="list">${rows}</ul></div>`;
  }

  function linesHTML(items, plan) {
    const groups = packGroups(items);
    const done = {};
    return items.map(it => {
      const id = packOf(it);
      const g = id ? groups[id] : null;
      if (packOk(g)) {
        if (done[id]) return '';
        done[id] = true;
        return packHTML(g, plan);
      }
      return lineHTML(planned(it, plan));
    }).join('');
  }

  async function removePack(id) {
    const updates = {};
    ((cart && cart.items) || []).forEach(it => { if (packOf(it) === id) updates[it.key] = 0; });
    if (!Object.keys(updates).length) return cart;
    try {
      cart = await req(R.update + '.js', { updates });
    } catch (e) {
      toast(e.message || T.error);
      return refresh().catch(() => cart);
    }
    render();
    emit('lp:cart:updated', { cart });
    return cart;
  }

  /* Ligne coffret orpheline (moins de 5 parfums dans son groupe) : retirée, une seule requête à la fois. */
  let pkFixing = false;
  function fixOrphans(c) {
    if (pkFixing || !c || !c.items) return;
    const updates = {};
    const groups = packGroups(c.items);
    Object.keys(groups).forEach(id => { const g = groups[id]; if (g.box && g.units < 5) updates[g.box.key] = 0; });
    if (!Object.keys(updates).length) return;
    pkFixing = true;
    req(R.update + '.js', { updates })
      .then(j => { cart = j; render(); emit('lp:cart:updated', { cart }); toast(PK_T.orphan); })
      .catch(() => {})
      .finally(() => { pkFixing = false; });
  }

  function bodyHTML(s) {
    if (!s.items.length) {
      return goalsHTML(s) + `<div class="dr-empty"><p>${esc(T.empty)}</p><a class="pill" href="${esc(URLS.emptyBtn || URLS.collection || R.root)}" data-cart-close>${esc(T.emptyBtn)}</a><a class="ul" href="${esc(URLS.emptyLink || URLS.quiz || R.root)}" data-cart-close>${esc(T.emptyLink)}</a></div>`;
    }
    const u = s.units;
    if (u < 3 || u > 4) up5Open = false;
    const plan = packPlan(s.items, s.disc);
    /* V35 : pochette offerte, sa valeur (prix réel du produit, LP_DATA.pochette.value) barrée à côté de « Offerte »,
       et son nom relié à sa fiche. Sans produit pochette en vente (value 0), rien n'est barré. */
    const pv = s.gift && D.pochette && D.pochette.value > 0 ? money(D.pochette.value) : '';
    const pvUrl = D.pochette && D.pochette.url ? D.pochette.url : '';
    const giftName = pvUrl ? `<a href="${esc(pvUrl)}">${esc(T.giftName)}</a>` : esc(T.giftName);
    const giftPrice = pv ? `<span class="ln-pr"><s>${pv}</s><b class="ln-free">${esc(T.giftPrice)}</b></span>` : esc(T.giftPrice);
    const lines = linesHTML(mergeView(s.items), plan) + (s.gift && D.pochette
      ? `<div class="ln gift lp-ln lp-ln-gift"><img src="${esc(D.pochette.img)}" alt="" width="64" height="64" loading="lazy" decoding="async"><div class="ln-t"><p class="ln-n">${giftName}</p>${pv ? `<span class="lp-save">${esc(fill(T.saved || '[amount] économisés', 'amount', pv))}</span>` : ''}</div><div class="ln-p">${giftPrice}</div></div>`
      : '');
    /* V3.7 : à 3 et 4 parfums, la pochette est déjà visible, sa valeur barrée, « offerte dès 5 parfums ». */
    const pvLock = pochVal();
    const lockLine = PM.lock !== false && !s.gift && u >= 3 && u < 5 && D.pochette && pvLock
      ? `<div class="ln gift lp-ln lp-ln-gift lp-ln-lock"><img src="${esc(D.pochette.img)}" alt="" width="64" height="64" loading="lazy" decoding="async"><div class="ln-t"><p class="ln-n">${esc(T.giftName)}</p><span class="lp-lock-t">${IC_LOCK}${esc(PM.lockText || '')}</span></div><div class="ln-p"><span class="ln-pr"><s>${money(pvLock)}</s></span></div></div>`
      : '';
    let ups = '';
    if (PM.up5 !== false && D.cartUpsell !== false && (u === 3 || u === 4)) {
      ups = up5HTML(u);
    } else if (D.cartUpsell !== false) {
      const inCart = new Set(s.items.map(perfumeOf).filter(Boolean));
      const giftNext = freeCount(u + 1) > freeCount(u);
      const missing = ORDER.filter(h => PERF[h].variantId && !inCart.has(h));
      const head = giftNext ? (u === 4 ? T.upGift5 : T.upGift3) : (u < 3 ? esc(T.upMore) : u === 3 ? esc(T.up3) : esc(T.up5));
      const cards = missing.map(h => {
        const p = PERF[h];
        const label = giftNext ? esc(T.upBtnGift) : esc(fill(T.upBtn, 'price', money(p.price)));
        const pr = giftNext ? `<s>${money(p.price)}</s> <b>${esc(T.lineFree)}</b>` : money(p.price);
        return `<div class="up-c lp-up"${pAttrs(p)}><img src="${esc(p.packshot)}" alt="" width="56" height="56" loading="lazy" decoding="async"><div class="lp-up-t"><p>${esc(p.cap)}</p>${p.sub ? `<span class="lp-up-sub">${esc(p.sub)}</span>` : ''}<span class="lp-up-pr">${pr}</span></div><form class="up-f" action="${esc(R.add)}" method="post"><input type="hidden" name="id" value="${p.variantId}"><input type="hidden" name="quantity" value="1"><button type="submit"${giftNext ? ' class="gift"' : ''} data-add-variant="${p.variantId}" aria-label="${esc(label + ' ' + p.cap)}"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5.5v13M5.5 12h13" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg></button></form></div>`;
      }).join('');
      const nCards = missing.length;
      const dots = nCards > 1 ? `<div class="lp-dots" aria-hidden="true">${Array.from({ length: nCards }, (_, k) => `<i${k === 0 ? ' class="lp-dot-on"' : ''}></i>`).join('')}</div>` : '';
      /* V3.7 : suggestions plus grandes, avec un titre visible quand le parfum suivant est offert. */
      const big = PM.big !== false;
      const hv = big && giftNext ? `<p class="ups-h lp-ups-h">${head}</p>` : '';
      if (cards) ups = `<div class="ups lp-ups${big ? ' lp-ups-big' : ''}" aria-label="${esc(head.replace(/<[^>]+>/g, ''))}">${hv}<div class="ups-row lp-ups-row">${cards}</div>${dots}</div>`;
    }
    const n = plan ? plan.freeUnits : s.free;
    const discLabel = esc(T.discount) + (n > 0 ? ` · ${n} ${esc(n > 1 ? T.freeMany : T.freeOne)}` : '');
    const sum = gwHTML(s) + `<dl class="sum lp-sum"><div><dt>${esc(T.subtotal)}</dt><dd>${money(s.orig)}</dd></div>`
      + (s.disc - s.codeDisc > 0 ? `<div class="off"><dt>${discLabel}</dt><dd>−${money(s.disc - s.codeDisc)}</dd></div>` : '')
      + (s.codeDisc > 0 ? `<div class="off"><dt>${esc(fill(PROMO.line || 'Code [code]', 'code', s.codeName))}</dt><dd>−${money(s.codeDisc)}</dd></div>` : '')
      + (s.gift ? `<div class="off"><dt>${esc(T.giftRow)}</dt><dd>${pv ? `<s class="lp-pv">${pv}</s> ` : ''}${esc(T.giftPrice)}</dd></div>` : '')
      + `<div><dt>${esc(T.shipping)}${s.ship > 0 && T.shipHint ? `<small>${esc(T.shipHint)}</small>` : ''}</dt><dd>${s.ship === 0 ? esc(T.shipFree) : money(s.ship)}</dd></div>`
      + `<div class="tot"><dt>${esc(T.total)}</dt><dd>${money(s.total)}</dd></div></dl>`
      + `<p class="dr-note">${esc(s.items.some(it => !!packOf(it)) && PK_T.note ? PK_T.note : (D.cartNote || D.deliveryNote))}</p>`
      + (D.safeNote ? `<p class="dr-note lp-safe-b">${esc(D.safeNote)}</p>` : '')
      + (D.trustText ? `<p class="dr-trust">${STAR}${esc(D.trustText)}</p>` : '');
    /* V58c (09/10) : panier épuré comme Rebelle : jauge, code, lignes, suggestions. Le total est dans le bouton. */
    return bannerHTML() + offerHTML() + goalsHTML(s, plan) + promoHTML() + `<div class="lns lp-lns">${lines}${lockLine}</div>` + ups + gwHTML(s);
  }

  function gwHTML(s) {
    if (!GW.enabled || !GW.variantId || !s.items.length) return '';
    const on = s.gw.length > 0;
    const attrs = (cart && cart.attributes) || {};
    const note = gwDraft != null ? gwDraft : String(attrs[GW.noteAttr] || '');
    const label = `${esc(GW.label)} · +${GW.price > 0 ? money(GW.price) : ''}`;
    const area = ''; /* V38 : plus de champ « petit mot » (demande de Maxime, 04/10) */
    return `<div class="gw${on ? ' on' : ''}"><label class="gw-c"><input type="checkbox" data-gw-toggle${on ? ' checked' : ''}><span class="gw-t"><b>${label}</b><small>${esc(GW.sub)}</small></span></label>${area}</div>`;
  }

  let gwBusy = false;
  async function gwSet(on) {
    if (gwBusy || !GW.variantId) return cart;
    gwBusy = true;
    try {
      const lines = ((cart && cart.items) || []).filter(isGW);
      if (on && !lines.length) {
        await req(R.add + '.js', { items: [{ id: Number(GW.variantId), quantity: 1 }] });
      } else if (!on) {
        gwDraft = null;
        clearTimeout(gwNoteT);
        gwNoteT = null;
        for (const it of lines) await req(R.change + '.js', { id: it.key, quantity: 0 });
        if (cart && cart.attributes && cart.attributes[GW.noteAttr]) await req(R.update + '.js', { attributes: { [GW.noteAttr]: '' } });
      }
    } catch (e) {
      toast(e.message || T.error);
    } finally {
      gwBusy = false;
    }
    return refresh().catch(() => cart);
  }

  let gwNoteT = null;
  let gwNoteP = null;
  let gwDraft = null;
  function gwSaveNote(value) {
    clearTimeout(gwNoteT);
    gwNoteT = null;
    const v = String(value || '').slice(0, GW.noteMax);
    const cur = String(((cart && cart.attributes) || {})[GW.noteAttr] || '');
    if (v === cur) return Promise.resolve(cart);
    /* Pas de nouveau rendu : le champ garde le focus pendant la saisie. */
    gwNoteP = req(R.update + '.js', { attributes: { [GW.noteAttr]: v } })
      .then(j => { if (j) cart = j; return cart; })
      .catch(e => { toast(e.message || T.error); return cart; })
      .finally(() => { gwNoteP = null; });
    return gwNoteP;
  }

  /* Pochette cadeau seule (plus aucun article) ou en plusieurs exemplaires : ramenée à 0 ou à 1. */
  let gwFixing = false;
  function gwFix(c) {
    if (gwFixing || gwBusy || !c || !c.items) return;
    const lines = c.items.filter(isGW);
    if (!lines.length) return;
    const others = c.items.some(it => !isGW(it) && !isFP(it));
    const target = others ? 1 : 0;
    const bad = lines.filter((it, i) => i > 0 || it.quantity !== target);
    if (!bad.length) return;
    gwFixing = true;
    (async () => {
      for (let i = 0; i < lines.length; i++) {
        const q = i === 0 ? target : 0;
        if (lines[i].quantity !== q) await req(R.change + '.js', { id: lines[i].key, quantity: q });
      }
      if (!others && c.attributes && c.attributes[GW.noteAttr]) await req(R.update + '.js', { attributes: { [GW.noteAttr]: '' } });
    })().catch(() => {}).finally(() => { gwFixing = false; refresh().catch(() => {}); });
  }

  /* V52 : pochette offerte en 1 exemplaire dès 5 parfums, sinon retirée. Une requête à la fois ; après 2 échecs
     (produit indisponible, réseau), plus d'essai sur cette page, pour ne pas boucler. Revérifiée au clic sur « Commander ». */
  const fpWanted = c => {
    let units = 0;
    ((c && c.items) || []).forEach(it => { if (perfumeOf(it)) units += it.quantity; });
    return D.giftEnabled !== false && units >= (D.giftMin || 5) ? 1 : 0;
  };
  const fpOk = c => {
    const lines = ((c && c.items) || []).filter(isFP);
    return fpWanted(c) ? lines.length === 1 && lines[0].quantity === 1 : lines.length === 0;
  };
  async function fpApply(c) {
    const lines = c.items.filter(isFP);
    const want = fpWanted(c);
    if (want && !lines.length) {
      await req(R.add + '.js', { items: [{ id: Number(FP.variantId), quantity: 1 }] });
      return;
    }
    const updates = {};
    lines.forEach((it, i) => { const q = i === 0 ? want : 0; if (it.quantity !== q) updates[it.key] = q; });
    if (Object.keys(updates).length) await req(R.update + '.js', { updates });
  }
  let fpFixing = false;
  let fpFails = 0;
  function fpFix(c) {
    if (fpFixing || !FP.variantId || fpFails >= 2 || !c || !c.items || fpOk(c)) return;
    fpFixing = true;
    fpApply(c)
      .catch(() => { fpFails += 1; })
      .finally(() => { fpFixing = false; refresh().catch(() => {}); });
  }
  async function fpEnsure() {
    if (!FP.variantId) return;
    try {
      const c = await req(R.cart + '.js');
      if (!fpOk(c)) await fpApply(c);
    } catch (e) {}
  }

  function render() {
    if (!cart) return;
    const s = stats(cart);
    const giftNext = s.units > 0 && freeCount(s.units + 1) > freeCount(s.units);
    $$('[data-cart-count]').forEach(el => { el.textContent = s.count; el.hidden = s.count === 0; });
    $$('[data-cart-title-count]').forEach(el => { el.textContent = s.count ? s.count : ''; });
    const html = bodyHTML(s);
    $$('[data-lp-cart]').forEach(root => {
      const body = $('[data-cart-body]', root);
      if (body) body.innerHTML = html;
      const foot = $('[data-cart-foot]', root);
      if (foot) foot.hidden = s.items.length === 0;
      $$('[data-cart-total]', root).forEach(el => { el.textContent = money(s.sub); });
      $$('[data-cart-orig]', root).forEach(el => { const on = s.items.length > 0 && s.orig > s.sub; el.hidden = !on; el.textContent = on ? money(s.orig) : ''; });
      $$('[data-cart-code]', root).forEach(el => { el.innerHTML = codeSlotHTML(); });
      /* V3.7 : « Vous économisez … » au-dessus de Commander (parfums offerts, code, et pochette quand elle est offerte). */
      $$('[data-cart-save]', root).forEach(el => {
        const sv = Math.max(0, s.orig - s.sub) + (s.gift ? pochVal() : 0);
        const on = PM.save !== false && s.items.length > 0 && sv > 0 && !!PM.saveText;
        el.hidden = !on;
        el.innerHTML = on ? esc(fill(PM.saveText, 'montant', '\u0001')).replace('\u0001', `<b>${money(sv)}</b>`) + (s.gift && pochVal() && PM.saveGift ? esc(PM.saveGift) : '') : '';
      });
      $$('.lp-ups-row', root).forEach(row => {
        const dots = row.parentNode && row.parentNode.querySelectorAll('.lp-dots i');
        if (!dots || !dots.length) return;
        row.addEventListener('scroll', () => {
          const c = row.firstElementChild; if (!c) return;
          const k = Math.min(dots.length - 1, Math.round(row.scrollLeft / (c.getBoundingClientRect().width + 10)));
          dots.forEach((d, j) => d.classList.toggle('lp-dot-on', j === k));
        }, { passive: true });
      });
      $$('[data-cart-express]', root).forEach(el => { el.hidden = giftNext; });
    });
    fixOrphans(cart);
    gwFix(cart);
    fpFix(cart);
  }

  /* ---------- Tiroir panier ---------- */
  let lastFocus = null;
  function openCart() {
    const d = $('#drawer');
    if (!d) { window.location.href = R.cart; return; }
    if (!d.classList.contains('open')) lastFocus = document.activeElement;
    closeMenu(true);
    d.removeAttribute('inert');
    d.classList.add('open');
    const sc = $('#scrim'); if (sc) sc.classList.add('on');
    lock();
    $$('[data-open-cart]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    const x = $('.dr-h [data-cart-close]', d);
    if (x) setTimeout(() => x.focus({ preventScroll: true }), 60);
  }
  function closeCart() {
    const d = $('#drawer');
    if (!d || !d.classList.contains('open')) return;
    d.classList.remove('open');
    d.setAttribute('inert', '');
    const sc = $('#scrim'); if (sc) sc.classList.remove('on');
    $$('[data-open-cart]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    unlock();
    if (lastFocus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    lastFocus = null;
  }

  /* ---------- Menu mobile (feuille plein écran) ----------
     Ouverture animée (classe .open), verrouillage du défilement, focus piégé dans le menu,
     Échap pour fermer, retour du focus au bouton d'origine. */
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  let menuReturn = null;
  function openMenu() {
    const m = $('#menu');
    if (!m || m.classList.contains('open')) return;
    menuReturn = document.activeElement;
    m.removeAttribute('inert');
    const b = $('.menu-b', m);
    if (b) b.scrollTop = 0;
    m.classList.add('open');
    document.documentElement.classList.add('menu-on');
    lock();
    $$('[data-menu-open]').forEach(x => x.setAttribute('aria-expanded', 'true'));
    const x = $('[data-menu-close]', m);
    if (x) setTimeout(() => x.focus({ preventScroll: true }), 60);
  }
  function closeMenu(silent) {
    const m = $('#menu');
    if (!m || !m.classList.contains('open')) return;
    m.classList.remove('open');
    m.setAttribute('inert', '');
    document.documentElement.classList.remove('menu-on');
    $$('[data-menu-open]').forEach(x => x.setAttribute('aria-expanded', 'false'));
    if (!silent) {
      unlock();
      const ok = el => el && el !== document.body && document.contains(el) && !el.closest('#menu') && el.getClientRects().length;
      const back = ok(menuReturn) ? menuReturn : $('[data-menu-open]');
      if (m.contains(document.activeElement)) { try { document.activeElement.blur(); } catch (e) {} }
      if (ok(back)) { try { back.focus({ preventScroll: true }); } catch (e) {} }
    }
    menuReturn = null;
  }
  /* Focus piégé : Tab et Maj+Tab restent dans le menu ouvert */
  document.addEventListener('keydown', e => {
    if (e.key !== 'Tab') return;
    const m = $('#menu');
    if (!m || !m.classList.contains('open')) return;
    const f = $$(FOCUSABLE, m).filter(el => el.offsetParent !== null || el.getClientRects().length);
    if (!f.length) return;
    const first = f[0];
    const last = f[f.length - 1];
    const cur = document.activeElement;
    if (!m.contains(cur)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
    if (e.shiftKey && cur === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && cur === last) { e.preventDefault(); first.focus(); }
  });
  /* Éditeur de thème : l'en-tête rechargé repart menu fermé, défilement libéré */
  document.addEventListener('shopify:section:load', e => {
    if (e.target && e.target.querySelector && e.target.querySelector('#menu')) {
      document.documentElement.classList.remove('menu-on');
      menuReturn = null;
      unlock();
    }
  });
  /* Passage en affichage ordinateur : le menu mobile se ferme */
  if (window.matchMedia) {
    const mq = window.matchMedia('(min-width:1000px)');
    const onMq = () => { if (mq.matches) closeMenu(); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
  }

  /* ---------- Modales ---------- */
  function openModal(id) {
    const m = document.getElementById(id);
    if (!m) return;
    m.hidden = false;
    const f = $('button, a[href], input, [tabindex]', m);
    if (f) f.focus({ preventScroll: true });
  }
  function closeModal(m) { if (m) { m.hidden = true; unlock(); } }

  /* ---------- Délégation globale ---------- */
  function busy(el, on) {
    if (!el) return;
    if (on) { el.setAttribute('aria-busy', 'true'); el.dataset.lpBusy = '1'; }
    else { el.removeAttribute('aria-busy'); delete el.dataset.lpBusy; }
  }

  document.addEventListener('click', e => {
    const t = e.target.closest('[data-add-variant],[data-add-many],[data-open-cart],[data-cart-qty],[data-cart-rm],[data-cart-pack-rm],[data-cart-close],[data-menu-open],[data-menu-close],[data-modal-open],[data-modal-close],[data-scroll-to]');
    if (!t) {
      if (e.target.classList && e.target.classList.contains('modal')) closeModal(e.target);
      const a = e.target.closest('a[href]');
      if (a && a.closest('#menu')) closeMenu();
      return;
    }
    const d = t.dataset;

    if (d.addVariant !== undefined) {
      e.preventDefault();
      if (t.disabled || d.lpBusy || !d.addVariant) return;
      const id = d.addVariant;
      const h = byVariant[String(id)];
      const name = (h && PERF[h].name) || d.name || '';
      busy(t, true);
      add([{ id, quantity: Number(d.qty) || 1 }], { open: d.open !== 'false' })
        .then(() => { if (name) toast(fill(T.added, 'name', name)); })
        .catch(() => {})
        .finally(() => busy(t, false));
      return;
    }
    if (d.addMany !== undefined) {
      e.preventDefault();
      if (t.disabled || d.lpBusy || !d.addMany) return;
      const ids = d.addMany.split(',').map(x => x.trim()).filter(Boolean);
      busy(t, true);
      add(ids.map(id => ({ id, quantity: 1 })), { open: d.open !== 'false' }).catch(() => {}).finally(() => busy(t, false));
      return;
    }
    if (d.openCart !== undefined) {
      e.preventDefault();
      openCart();
      refresh().catch(() => {});
      return;
    }
    if (d.cartQty !== undefined) {
      e.preventDefault();
      if (d.lpBusy) return;
      busy(t, true);
      change(d.cartQty, Number(d.qty)).finally(() => busy(t, false));
      return;
    }
    if (d.cartRm !== undefined) {
      e.preventDefault();
      if (d.lpBusy) return;
      busy(t, true);
      change(d.cartRm, 0).finally(() => busy(t, false));
      return;
    }
    if (d.cartPackRm !== undefined) {
      e.preventDefault();
      if (d.lpBusy) return;
      busy(t, true);
      removePack(d.cartPackRm).finally(() => busy(t, false));
      return;
    }
    if (d.cartClose !== undefined) {
      if (t.tagName !== 'A') e.preventDefault();
      closeCart();
      closeMenu();
      return;
    }
    if (d.menuOpen !== undefined) { e.preventDefault(); openMenu(); return; }
    if (d.menuClose !== undefined) { e.preventDefault(); closeMenu(); return; }
    if (d.modalOpen !== undefined) { e.preventDefault(); openModal(d.modalOpen); return; }
    if (d.modalClose !== undefined) { e.preventDefault(); closeModal(t.closest('.modal')); return; }
    if (d.scrollTo !== undefined) {
      const el = document.getElementById(d.scrollTo);
      if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  });

  /* V38 : pochette cadeau (case et petit mot) */
  document.addEventListener('change', e => {
    const box = e.target.closest && e.target.closest('[data-gw-toggle]');
    if (box) {
      box.disabled = true;
      gwSet(box.checked).finally(() => { box.disabled = false; });
      return;
    }
    const note = e.target.closest && e.target.closest('[data-gw-note]');
    if (note) gwSaveNote(note.value);
  });
  document.addEventListener('input', e => {
    const note = e.target.closest && e.target.closest('[data-gw-note]');
    if (!note) return;
    const cnt = note.parentNode && note.parentNode.querySelector('.gw-cnt');
    gwDraft = note.value;
    if (cnt) cnt.textContent = note.value.length + '/' + GW.noteMax;
    clearTimeout(gwNoteT);
    gwNoteT = setTimeout(() => gwSaveNote(note.value), 700);
  });
  document.addEventListener('submit', e => {
    const f = e.target;
    if (!f || !f.classList || !f.classList.contains('dr-co')) return;
    if (!gwNoteT && !gwNoteP && !FP.variantId) return;
    e.preventDefault();
    const go = () => { const btn = $('[name="checkout"]', f); const i = document.createElement('input'); i.type = 'hidden'; i.name = 'checkout'; i.value = btn ? btn.value || '' : ''; f.appendChild(i); f.submit(); };
    /* V52 : pochette offerte revérifiée juste avant le paiement (4 s au plus). */
    const fp = () => Promise.race([fpEnsure(), new Promise(r => setTimeout(r, 4000))]);
    qtyIdle().then(() => (gwNoteT && gwDraft != null ? gwSaveNote(gwDraft) : gwNoteP || Promise.resolve())).then(fp, fp).then(go, go);
  });

  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    closeCart();
    closeMenu();
    $$('.modal:not([hidden])').forEach(m => { m.hidden = true; });
    unlock();
  });

  /* ---------- Bandeau d'annonce tournant ---------- */
  function initAnn(root) {
    $$('.ann', root || document).forEach(ann => {
      if (ann._lpT) clearInterval(ann._lpT);
      const items = $$(':scope > a', ann);
      if (!items.length) return;
      if (!items.some(x => x.classList.contains('on'))) items[0].classList.add('on');
      if (items.length < 2) return;
      const ms = Math.max(1500, Number(ann.dataset.interval) || 4200);
      ann._lpT = setInterval(() => {
        if (ann._lpPause) return;
        const i = items.findIndex(x => x.classList.contains('on'));
        items.forEach(x => x.classList.remove('on'));
        items[(i + 1) % items.length].classList.add('on');
      }, ms);
    });
  }

  /* ---------- En-tête ---------- */
  let hdrTick = false;
  function onScroll() {
    const h = $('.hdr');
    if (h) h.classList.toggle('solid', window.scrollY > 40);
  }
  window.addEventListener('scroll', () => {
    if (hdrTick) return;
    hdrTick = true;
    requestAnimationFrame(() => { hdrTick = false; onScroll(); });
  }, { passive: true });

  /* ---------- Apparitions douces au défilement (réglage « Apparitions douces ») ----------
     Seuls les éléments situés sous la ligne de flottaison au chargement sont masqués puis révélés :
     rien ne clignote au-dessus de la ligne, rien n'est masqué si le script ne tourne pas. */
  const RV_SEL = '.sh, .grid > .cd, .grid > .tile, .rvs > .rv, .tiers > .tier, .steps3 > figure, .facts, .split > *, .story, .sugs > .sug, .give > *';
  const RV_SKIP = '#menu, #drawer, .sticky, .tray, .modal, .smell-box, .hours, .rail';
  let rvIO = null;
  function reveal(root) {
    const flag = $('[data-lp-reveal]');
    if (!flag || !('IntersectionObserver' in window)) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('lp-rv');
    if (!rvIO) {
      rvIO = new IntersectionObserver(es => es.forEach(en => {
        if (!en.isIntersecting) return;
        en.target.classList.add('lp-in');
        rvIO.unobserve(en.target);
      }), { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    }
    const vh = window.innerHeight || 800;
    $$(RV_SEL, root || document).forEach(el => {
      if (el._lpRv || el.closest(RV_SKIP)) return;
      el._lpRv = true;
      if (el.getBoundingClientRect().top < vh * 0.92) return;
      const sibs = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--rd', (Math.max(0, sibs) % 3) * 70 + 'ms');
      el.classList.add('lp-r');
      rvIO.observe(el);
    });
  }

  /* ---------- Apparitions : classe .in sur .pc, .ac, .ct ---------- */
  const REVEAL = '.pc, .ac, .ct';
  let io = null;
  function observe(root) {
    const scope = root || document;
    const els = $$(REVEAL, scope);
    if (scope.matches && scope.matches(REVEAL)) els.push(scope);
    const todo = els.filter(el => !el.classList.contains('in') && !el._lpSeen);
    if (!todo.length) return;
    if (!('IntersectionObserver' in window)) { todo.forEach(el => el.classList.add('in')); return; }
    if (!io) {
      io = new IntersectionObserver(es => es.forEach(en => {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      }), { threshold: 0.25 });
    }
    todo.forEach(el => { el._lpSeen = true; io.observe(el); });
  }
  if ('MutationObserver' in window) {
    let pending = false;
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; observe(document); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- Points des cartes produit (défilement horizontal de .cd-sl) ---------- */
  document.addEventListener('scroll', e => {
    const sl = e.target;
    if (!sl || !sl.classList || !sl.classList.contains('cd-sl')) return;
    const i = Math.round(sl.scrollLeft / (sl.offsetWidth || 1));
    const dots = sl.parentElement && $('.cd-dots', sl.parentElement);
    if (dots) $$('i', dots).forEach((dot, j) => dot.classList.toggle('on', j === i));
  }, { capture: true, passive: true });

  /* ---------- Rangées de puces : puce active visible ---------- */
  function centerChips(root) {
    $$('.chips', root || document).forEach(row => {
      const on = $('.chip.on', row);
      if (on) row.scrollLeft = on.offsetLeft - row.offsetLeft - 20;
    });
  }

  /* ---------- Éditeur de thème ---------- */
  document.addEventListener('shopify:section:load', e => { initAnn(e.target); observe(e.target); centerChips(e.target); onScroll(); render(); });
  document.addEventListener('shopify:section:unload', e => { $$('.ann', e.target).forEach(a => { if (a._lpT) clearInterval(a._lpT); }); });
  document.addEventListener('shopify:block:select', e => {
    const b = e.target;
    const ann = b.closest && b.closest('.ann');
    if (ann) {
      ann._lpPause = true;
      $$(':scope > a', ann).forEach(x => x.classList.toggle('on', x === b));
    }
    if (b.closest && b.closest('#menu')) openMenu();
  });
  document.addEventListener('shopify:block:deselect', e => {
    const ann = e.target.closest && e.target.closest('.ann');
    if (ann) ann._lpPause = false;
    if (e.target.closest && e.target.closest('#menu')) closeMenu();
  });

  /* ---------- Retour arrière (cache du navigateur) ---------- */
  window.addEventListener('pageshow', e => { if (e.persisted) refresh().catch(() => {}); });

  /* ---------- API publique ---------- */
  window.LP = Object.assign(window.LP || {}, {
    data: D,
    money,
    toast,
    freeCount,
    observe,
    lock,
    unlock,
    cart: {
      add,
      change,
      removePack,
      giftWrap: gwSet,
      refresh,
      render,
      open: openCart,
      close: closeCart,
      get: () => cart
    },
    menu: { open: openMenu, close: closeMenu },
    modal: { open: openModal, close: id => closeModal(typeof id === 'string' ? document.getElementById(id) : id) }
  });

  /* V58m : retour immédiat sur les cartes du panier. */
  document.addEventListener('click', e => {
    const q = e.target.closest && e.target.closest('[data-lp-q]');
    const rmv = !q && e.target.closest && e.target.closest('[data-lp-rm]');
    if (!q && !rmv) return;
    e.preventDefault();
    const el = q || rmv;
    const gid = el.getAttribute(q ? 'data-lp-q' : 'data-lp-rm');
    const g = VIEW[gid];
    if (!g) return;
    const cur = pendQ[gid] != null ? pendQ[gid] : (flyQ[gid] != null ? flyQ[gid] : g.qty);
    const next = rmv ? 0 : Math.max(0, cur + Number(q.getAttribute('data-lp-d') || 0));
    if (next === cur && !rmv) return;
    pendQ[gid] = next;
    const card = el.closest('.ln');
    if (card) {
      const sp = card.querySelector('.qty span');
      if (sp) sp.textContent = next;
      if (next === 0) { card.classList.add('lp-ln-out'); setTimeout(() => { card.style.display = 'none'; }, 170); }
    }
    markPending(true);
    clearTimeout(qTimer);
    qTimer = setTimeout(flushQty, next === 0 ? 0 : 320);
  });
  /* Ajout depuis une suggestion : la carte apparaît tout de suite (en attente), le panier se redessine à la réponse. */
  document.addEventListener('click', e => {
    const b = e.target.closest && e.target.closest('.lp-up [data-add-variant]');
    if (!b || b.disabled || b.dataset.lpBusy) return;
    const card = b.closest('.lp-up');
    const h = byVariant[String(b.dataset.addVariant)];
    const p = h && PERF[h];
    const root = card && card.closest('[data-lp-cart]');
    const lns = root && root.querySelector('.lp-lns');
    if (!p || !lns) return;
    const gift = b.classList.contains('gift');
    lns.insertAdjacentHTML('afterbegin', `<div class="ln lp-ln lp-ln-ghost"${pAttrs(p)}><img src="${esc(p.packshot)}" alt="" width="64" height="64"><div class="ln-t"><p class="ln-n">${esc(p.name)}</p>${p.sub ? `<p class="lp-ln-sub">${esc(p.sub)}</p>` : ''}</div><div class="ln-p">${gift ? `<b class="ln-free">${esc(T.lineFree)}</b>` : money(p.price)}<div class="qty"><span>1</span></div></div></div>`);
    card.classList.add('lp-up-out');
    markPending(true);
  }, true);
  document.addEventListener('lp:cart:updated', () => markPending(false));
  /* V3.7 : « Choisir mes 2 parfums » ouvre les six parfums en grand dans la carte « Passez à 5 parfums ». */
  document.addEventListener('click', e => {
    const b = e.target.closest && e.target.closest('[data-lp-up5]');
    if (!b) return;
    e.preventDefault();
    up5Open = true;
    const box = b.closest('.lp-up5');
    if (!box) return;
    box.classList.add('lp-up5-open');
    const g = box.querySelector('.lp-up5-g');
    b.remove();
    if (g) { g.hidden = false; try { g.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (x) {} }
  });

  /* ---------- Démarrage ---------- */
  tickCd();
  setInterval(tickCd, 1000);

  /* V58 : copier le code, puis le coller et l'appliquer dans le panier. */
  function copyText(txt) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(txt);
    return new Promise((ok, ko) => {
      const ta = document.createElement('textarea');
      ta.value = txt; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy') ? ok() : ko(); } catch (e) { ko(e); }
      ta.remove();
    });
  }
  async function setCodes(list) {
    await req(R.update + '.js', { discount: list.join(',') });
    await refresh();
  }
  document.addEventListener('click', e => {
    const cp = e.target.closest && e.target.closest('[data-lp-copy]');
    if (cp) {
      e.preventDefault();
      const box = cp.closest('[data-lp-cart]');
      const lab = cp.querySelector('[data-lp-copy-l]');
      const was = lab ? lab.innerHTML : '';
      copyText(PROMO.code).then(() => {
        cp.classList.add('lp-code-ok');
        if (lab) lab.textContent = PROMO.copied;
        setTimeout(() => { cp.classList.remove('lp-code-ok'); if (lab) lab.innerHTML = was; }, 2500);
        const inp = box && box.querySelector('[data-lp-code-in]');
        if (inp) inp.focus({ preventScroll: false });
      }).catch(() => { if (lab) lab.textContent = PROMO.code; });
      return;
    }
    const rm = e.target.closest && e.target.closest('[data-lp-code-rm]');
    if (rm) {
      e.preventDefault();
      const c = String(rm.getAttribute('data-lp-code-rm') || '').toUpperCase();
      if (codeBusy) return;
      codeBusy = true;
      rm.setAttribute('aria-busy', 'true');
      promoErr = '';
      setCodes(codesOn().filter(x => x.toUpperCase() !== c)).catch(() => refresh().catch(() => cart)).finally(() => { codeBusy = false; });
    }
  });
  document.addEventListener('submit', e => {
    const f = e.target.closest && e.target.closest('[data-lp-code-f]');
    if (!f) return;
    e.preventDefault();
    const inp = f.querySelector('[data-lp-code-in]');
    const code = String(inp && inp.value || '').trim().replace(/\s+/g, '').toUpperCase();
    const btn = f.querySelector('button');
    /* V3.11 (Clarity : clics sans effet sur « Appliquer ») : champ vide = message, champ souligné qui tremble, curseur dedans. */
    if (!code) {
      promoErr = PROMO.empty;
      render();
      const nf = $$('[data-lp-code-f]').find(x => x.offsetParent);
      if (nf) { nf.classList.remove('is-err'); void nf.offsetWidth; nf.classList.add('is-err'); const ni = nf.querySelector('[data-lp-code-in]'); if (ni) ni.focus({ preventScroll: true }); }
      return;
    }
    /* Un seul essai à la fois ; l'ancien message disparaît tout de suite et le bouton montre « … ». */
    if (codeBusy) return;
    codeBusy = true;
    promoErr = '';
    const oldErr = f.parentNode && f.parentNode.querySelector('.lp-code-e');
    if (oldErr) oldErr.remove();
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.textContent = '…'; }
    f.classList.add('is-busy');
    const before = codesOn();
    /* V58k (10/10) : Shopify peut répondre « erreur » tout en appliquant le code. Après chaque essai, on relit donc le vrai
       panier et on affiche ce qui est réellement appliqué. */
    const done = () => refresh().catch(() => cart).then(() => {
      if (codesOn().some(x => x.toUpperCase() === code)) { promoErr = ''; render(); return; }
      promoErr = PROMO.error;
      /* Code refusé : on remet les codes d'avant pour ne pas laisser un code invalide dans le panier. */
      const left = ((cart && cart.discount_codes) || []).some(x => String(x.code || '').toUpperCase() === code);
      if (left) return setCodes(before).catch(() => refresh().catch(() => cart)).then(() => render());
      render();
    }).finally(() => { codeBusy = false; });
    setCodes(before.filter(x => x.toUpperCase() !== code).concat(code)).then(done, done);
  });
  function init() {
    initAnn();
    onScroll();
    observe();
    reveal();
    centerChips();
    if (cart) render(); else refresh().catch(() => {});
    if (/[?&]customer_posted=true/.test(window.location.search)) toast(T.newsletter);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
